/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipients_2Inputs */

const da_privacy_recipients_2 = /** @type {(inputs: Privacy_Recipients_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan få den aktuelle liste med leverandørernes navne og lande ved at skrive til os, og den indgår i databehandleraftalen med skolerne. Bruger en leverandør underleverandører uden for EU, sker overførslen kun på grundlag af EU-Kommissionens standardkontraktbestemmelser eller EU-U.S. Data Privacy Framework.`)
};

/** @type {(inputs: Privacy_Recipients_2Inputs) => LocalizedString} */
const en_privacy_recipients_2 = da_privacy_recipients_2;

/**

* @param {Privacy_Recipients_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipients_2 = /** @type {((inputs?: Privacy_Recipients_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipients_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipients_2(inputs)
	return /** @type {LocalizedString} */ ("Du kan få den aktuelle liste med leverandørernes navne og lande ved at skrive til os, og den indgår i databehandleraftalen med skolerne. Bruger en leverandør underleverandører uden for EU, sker overførslen kun på grundlag af EU-Kommissionens standardkontraktbestemmelser eller EU-U.S. Data Privacy Framework.")
});